const translations = {
    badRequest: 'Tried sending a bad request'
};

export default translations;
